import instance from '../../axios';

export const getSalesPerformanceForHome = async (from, to, type) => {
  const response = await instance.get(
    'sales-performance/GetForHome?from=' + from + '&to=' + to + '&type=' + type
  );
  return response.data;
};

export const getSalesPerformancePerSales = async (from, to, id) => {
  const response = await instance.get(
    'sales-performance/GetBySales?from=' + from + '&to=' + to + '&id=' + id
  );
  return response.data;
};

export const getTracker = async (from, to, id) => {
  const response = await instance.get(
    'sales-performance/GetTracker?from=' + from + '&to=' + to + '&id=' + id
  );
  return response.data;
};

export const getSalesPerformanceForHomeOwner = async (month, year) => {
  const response = await instance.get(
    'sales-performance/GetForHomeOwner?month=' + month + '&year=' + year
  );
  return response.data;
};

export const getSalesVisitRank = async (month, year) => {
  const response = await instance.get(
    'sales-performance/GetVisitRank?month=' + month + '&year=' + year
  );
  return response.data;
};
